import styles from './error.module.css'

const ErrorMessage = ({ text }) => {
  return (
    <div className={styles.error}>
      <svg
        width="17"
        height="17"
        viewBox="0 0 17 17"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <circle cx="8.5" cy="8.5" r="8.5" fill="#B93333" />
        <path
          d="M8.93457 4.9541L8.87598 9.66113H8.11426L8.05566 4.9541H8.93457ZM8.49512 12.0488C8.33887 12.0488 8.20703 11.9951 8.09961 11.8877C7.99219 11.7803 7.93848 11.6484 7.93848 11.4922C7.93848 11.3327 7.99219 11.2008 8.09961 11.0967C8.20703 10.9893 8.33887 10.9355 8.49512 10.9355C8.65462 10.9355 8.78646 10.9893 8.89062 11.0967C8.99805 11.2008 9.05176 11.3327 9.05176 11.4922C9.05176 11.6484 8.99805 11.7803 8.89062 11.8877C8.78646 11.9951 8.65462 12.0488 8.49512 12.0488Z"
          fill="white"
        />
      </svg>
      <div className={styles.text} dangerouslySetInnerHTML={{ __html: text }} />
    </div>
  )
}

export default ErrorMessage
